import * as THREE from 'three';
import { MAP } from '../config.js';

/**
 * マップ表示で歩いていないときのカメラ。見る地点の真上から見下ろし、ドラッグで地図をずらす。
 * 歩いているときは walkMode がキャラを追って見下ろす。
 */
export function createMapCamera({ camera, canvas }) {
  const focus = new THREE.Vector3();
  let height = MAP.heightWide;
  let active = false;
  let dragging = null;

  const onPointerDown = (e) => {
    if (!active) return;
    dragging = { x: e.clientX, y: e.clientY };
  };
  const onPointerMove = (e) => {
    if (!active || dragging === null) return;
    // 画面上の移動量を、今の高さで見えている床の広さに合わせて換算する
    const metersPerPixel = (2 * height * Math.tan((camera.fov * Math.PI) / 360)) / Math.max(canvas.clientHeight, 1);
    focus.x -= (e.clientX - dragging.x) * metersPerPixel;
    /*
     * 斜めから見下ろしているぶん、画面の縦方向は床の上では長く見えている。
     * 補正しないと、上下のドラッグで指の動きより地図が動かず、手応えがずれる。
     */
    const lean = Math.cos(Math.atan(MAP.tilt));
    focus.z -= ((e.clientY - dragging.y) * metersPerPixel) / lean;
    dragging = { x: e.clientX, y: e.clientY };
  };
  const onPointerUp = () => {
    dragging = null;
  };
  canvas.addEventListener('pointerdown', onPointerDown, { passive: true });
  canvas.addEventListener('pointermove', onPointerMove, { passive: true });
  canvas.addEventListener('pointerup', onPointerUp, { passive: true });
  canvas.addEventListener('pointercancel', onPointerUp, { passive: true });

  return {
    setActive(next) {
      active = Boolean(next);
      if (!active) dragging = null;
    },
    /** 見下ろす地点（床の上） */
    setFocus(x, y, z) {
      focus.set(x, y, z);
    },
    get focus() {
      return focus.clone();
    },
    setHeight(next) {
      height = next;
    },
    update() {
      camera.position.set(focus.x, focus.y + height, focus.z + height * MAP.tilt);
      camera.lookAt(focus);
    },
  };
}

/** ズーム値（0 引き〜1 寄り）からマップ表示のカメラの高さを求める */
export function mapHeightFor(value) {
  return MAP.heightWide + (MAP.heightNarrow - MAP.heightWide) * value;
}
